import { ITipoTelefone } from "../../../../../../../Interfaces/Geral/TipoTelefone/TipoTelefoneInterfaces";
import { Dispatch, SetStateAction } from "react";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ITelefonesCliente } from "../../../../../../../Interfaces/Geral/Cliente/IClienteSimples";
import ReactInputMask from "react-input-mask";

interface ITelefones {
    lstTipoTelefone: ITipoTelefone[] | undefined;
    handleAddPhone: (data: any) => void;
    novoTelefone: ITelefonesCliente;
    setNovoTelefone: Dispatch<SetStateAction<ITelefonesCliente>>;
    customDDI: string;
    setCustomDDI: Dispatch<SetStateAction<string>>;
}

export default function Telefones(props: ITelefones) {
    return (
        <div className="row p-2">
            <div className="col-lg-4 mb-3">
                <label>DDI: *</label>
                <select
                    className="form-control"
                    name="DDI"
                    value={props.novoTelefone.DDI}
                    onChange={(e) => {
                        const value = e.target.value;
                        props.setNovoTelefone({
                            ...props.novoTelefone,
                            DDI: value,
                        });
                        props.setCustomDDI(value);
                    }}
                    defaultValue="+55"
                >
                    <option value="+55">+55 (Brasil)</option>
                    <option value="+1">+1 (EUA)</option>
                    <option value="outro">Outro</option>
                </select>
            </div>
            {props.customDDI === "outro" && (
                <div className="col-12 col-lg-4 mb-3">
                    <label>DDI: *</label>
                    <ReactInputMask
                        type="tel"
                        className={"form-control placeholder-dark-50"}
                        placeholder={"DDI"}
                        value={props.novoTelefone.DDI}
                        mask={"+999"}
                        onChange={(e) => {
                            const value = e.target.value.replace('_', '');
                            props.setNovoTelefone({
                                ...props.novoTelefone,
                                DDI: value,
                            });
                        }}
                    />
                </div>
            )}
            <div className="col-12 col-lg-4 mb-3">
                <label>DDD: *</label>
                <input
                    type="text"
                    className="form-control"
                    name="DDD"
                    value={props.novoTelefone.DDD}
                    onChange={(e) =>
                        props.setNovoTelefone({
                            ...props.novoTelefone,
                            DDD: e.target.value,
                        })
                    }
                />
            </div>

            <div className="col-12 col-lg-4 mb-3">
                <label>Número do Telefone: *</label>
                <input
                    name="NR_TELEFONE"
                    className="form-control"
                    type="tel"
                    placeholder="Digite o telefone"
                    value={props.novoTelefone.NR_TELEFONE}
                    onChange={(e) =>
                        props.setNovoTelefone({
                            ...props.novoTelefone,
                            NR_TELEFONE: e.target.value,
                        })
                    }
                    maxLength={15}
                    required
                />
            </div>

            <div className="col-12 col-lg-4 mb-3">
                <label>Tipo do Telefone: *</label>
                <select
                    name="ID_TIPO_TELEFONE"
                    className="form-control"
                    value={props.novoTelefone.ID_TIPO_TELEFONE}
                    onChange={(e) => {
                        const selectedId = Number(e.target.value);
                        const selectedTipo = props.lstTipoTelefone?.find(
                            (tipo) => tipo.ID_TIPO_TELEFONE === selectedId
                        );

                        if (selectedTipo) {
                            props.setNovoTelefone({
                                ...props.novoTelefone,
                                ID_TIPO_TELEFONE: selectedId,
                                DS_TIPO_TELEFONE: selectedTipo.DS_TIPO_TELEFONE,
                            });
                        }
                    }}
                    required
                >
                    <option value=""></option>
                    {props.lstTipoTelefone?.map((tipo) => (
                        <option
                            key={tipo.ID_TIPO_TELEFONE}
                            value={tipo.ID_TIPO_TELEFONE}
                        >
                            {tipo.DS_TIPO_TELEFONE}
                        </option>
                    ))}
                </select>
            </div>

            <div className="col-lg-4 mb-3">
                <label>Adicionar Ramal:</label>
                <input
                    name="RAMAL"
                    type="number"
                    className="form-control"
                    value={props.novoTelefone.RAMAL}
                    onChange={(e) =>
                        props.setNovoTelefone({
                            ...props.novoTelefone,
                            RAMAL: Number(e.target.value),
                        })
                    }
                />
            </div>
            <div className="col-lg-12 mb-3">
                <label>Observação</label>
                <textarea
                    name="DS_OBSERVACAO"
                    className="form-control"
                    value={props.novoTelefone.DS_OBSERVACAO}
                    onChange={(e) =>
                        props.setNovoTelefone({
                            ...props.novoTelefone,
                            DS_OBSERVACAO: e.target.value,
                        })
                    }
                />
            </div>
            <div className="col-12 d-flex justify-content-end mt-3">
                <button
                    type="button"
                    className="btn btn-success"
                    onClick={props.handleAddPhone}
                >
                    <FontAwesomeIcon icon={faSave} /> Salvar Telefone
                </button>
            </div>
        </div>
    );
}
